import React from "react";
import GppMaybeOutlinedIcon from "@mui/icons-material/GppMaybeOutlined";
import profile from "../../../assets/img/NOKLogo.png";
import DropdownComponent from "../DropdownComponent";
import { useLocation } from "react-router-dom/cjs/react-router-dom";


const DefaultMessageScreen = ({
  selectedCompany,
  setSelectedCompany,
  selectedYear,
  setSelectedYear,
  selectedQuarter,
  setSelectedQuarter,
  summaryLoading,
  buttonStyle,
  handleSendMessage,
  tabValue,
  handleRadioChange,
  modelName,
  handleModelChange,
  questionTAB,
  handleExampleClick,
  setsummaryEndMonth,
  setsummaryStartMonth,
  setsummaryStartYear,
  setsummaryEndYear,
  setRegion,
  setTechnology,
  summaryStartMonth,
  summaryEndMonth,
  summaryStartYear,
  summaryEndYear,
  region,
  technology
}) => {
  const location = useLocation(); // Get the current location object

  return (
    <div >
      <div
        style={{
          display: "grid",
          gridGap: "1rem",
        }}
      >
        <div
          style={{
            fontSize: "34px",
            fontWeight: "600",
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <img style={{ width: "50px" }} src={profile} alt="logo" className="rounded ml-[10px]" />
        </div>

        <div
          style={{
            fontSize: "34px",
            fontWeight: "600",
            paddingLeft: "10px",
          }}
        >
          Hello Again!
        </div>
        <div style={{ paddingLeft: "10px" }}>
        Please choose what's on your mind.
        </div>

        <div className="human-reviewer-disclosure-banner">
          <div className="tooltip-icon">
            <GppMaybeOutlinedIcon sx={{ fontSize: "30px" }} />
          </div>
          <div className="message-container gmat-body-1">
            <div className="tooltip-content">
            Your gateway to timely, data-driven intelligence on the Fixed Wireless Access (FWA) market in France. Our platform empowers you to select custom date ranges and instantly generate clear, concise summaries of market trends, competitive movements, and emerging opportunities.
            </div>
          </div>
        </div>

        {/* // dropdown and radio button container starts */}

        <div
          style={{
            display: "flex",
            flexDirection: "column",
            // justifyContent: "flex-end",
            gap: "20px",
          }}
        >
          {location.pathname === "/Generate-Summary" && (
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                alignContent: "center",
                gap: "20px",
                alignItems: "center",
                flexWrap: "wrap",
              }}
            >
              <DropdownComponent
                selectedCompany={selectedCompany}
                setSelectedCompany={setSelectedCompany}
                selectedYear={selectedYear}
                setSelectedYear={setSelectedYear}
                selectedQuarter={selectedQuarter}
                setSelectedQuarter={setSelectedQuarter}

                setsummaryEndMonth={setsummaryEndMonth}
                setsummaryStartMonth={setsummaryStartMonth}
                setsummaryStartYear={setsummaryStartYear}
                setsummaryEndYear={setsummaryEndYear}
                setRegion={setRegion}
                setTechnology={setTechnology}
                summaryStartMonth={summaryStartMonth}
                summaryEndMonth={summaryEndMonth}
                summaryStartYear={summaryStartYear}
                summaryEndYear={summaryEndYear}
                region={region}
                technology={technology}


              />
              {/* // generate summary button  */}
              <div
                style={{
                  marginTop: "20px",
                }}
              >
                {!summaryLoading ? (
                  <button
                    className="bg-[#005aff] hover:bg-[#005aff]/50 text-white font-bold py-2 px-4 rounded disabled:opacity-50 border-none"
                    onClick={() => handleSendMessage("summary")}
                    disabled={
                      !(summaryStartMonth && summaryEndMonth && summaryStartYear && summaryEndYear && region && technology)
                    }
                  >
                    Generate summary
                  </button>
                ) : (
                  <button
                    style={buttonStyle(
                      !(selectedCompany && selectedYear && selectedQuarter)
                    )}
                    disabled={true}
                  >
                    {" "}
                    Loading...{" "}
                  </button>
                )}
              </div>
            </div>
          )}

          {(location.pathname === "/" ||
            location.pathname === "/Generate-Summary") && (
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                gap: "20px",
              }}
            >
            </div>
          )}
        </div>

        {location.pathname === "/" && (
          <div
            style={{
              paddingLeft: "10px",
              fontWeight: "600",
              display: "grid",
              gap: "10px",
            }}
          >
            <span>Related frequently asked questions</span>

            <div className="newTabSelectDiv">
            
              <>
                {questionTAB.map((item, index) => (
                  <div
                    className="bg-white px-4 py-3 rounded-lg cursor-pointer hover:bg-red-200 border"
                    key={index}
                    onClick={() => handleExampleClick(item.text)}
                  >
                    <div>
                      <span>{item.text}</span>
                    </div>
                  </div>
                ))}
              </>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default DefaultMessageScreen;
